import App from '.';
import SeoPage from './pages/SeoPage';

export default [
  {
    component: App,
    routes: [
      {
        alias: 'seopage',
        path: '/prix-de-l-immo/',
        component: SeoPage,
      },
    ],
  },
];
